module.exports = __webpack_public_path__ + "media/ringtone.45a767f2.mp3";